import React from 'react';
import Header from './Header';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faItchIo} from '@fortawesome/free-brands-svg-icons';
import {faLinkedin} from '@fortawesome/free-brands-svg-icons';
import './style/About.css';

/**
 *
 * @return {object}
 */
export default function About() {
  return (
    <div>
      <Header></Header>
      <Container container spacing={2} sx={{width: 2/3}} className='background'>
        <Box>
          <h4 className='grabber'>Hi! I'm Anika</h4>
          <h5 className='about'>I am a Creative Technology and Design PhD
            student at the <a href="https://www.colorado.edu/atlas/"
            target="_blank" className="link" rel="noopener noreferrer">ATLAS
            Institute</a> at University of Colorado, Boulder advised by <a href="https://www.colorado.edu/cs/mark-gross"
            className="link" target="_blank" rel="noopener noreferrer">
            Dr. Mark Gross</a>, <a href="https://www.colorado.edu/fiske/dr-john-keller" className="link"
            target="_blank" rel="noopener noreferrer">Dr. John Keller</a>, and
          <a href="https://www.colorado.edu/atlas/ellen-yi-luen-do" className="link"
            target="_blank" rel="noopener noreferrer"> Dr. Ellen Do</a> in the
             ACME Lab.</h5>
          <h5 className='about'>Sitting at the intersection of human-computer
             interaction and astronomy education research, my work explores
             how we can use technology as a medium to add interaction into
             planetariums. My goal is to design educational technology that
             leverages the benefits of both immersion and interaction within
             the dome.
          </h5>
          <h5 className='about'>I graduated in June 2023 from UC Santa Cruz
            with a B.S. in Computer Science: Computer Game Design and a minor
            in Astrophysics. There, I worked with <a href="https://marjcuerdo.github.io/index.html"
            target="_blank" rel="noopener noreferrer" className="link">
              Dr. Marj Cuerdo</a> and
          <a className="link" href="http://edwardmelcer.net/index.html" target="_blank"
            rel="noopener noreferrer"> Dr. Eddie Melcer </a>
            at the <a href="https://altgameslab.soe.ucsc.edu/" className="link"
            target="_blank" rel="noopener noreferrer"> Alternative Learning
              Technologies & Games Lab</a>. <br></br>
          <a className="icon" href="https://anikam.itch.io/" rel="noreferrer" target="_blank">
            <FontAwesomeIcon size="1x" color='black' icon={faItchIo} />
          </a>&nbsp;&nbsp;
          <a className="cv" href="./assets/AnikaMahajanCV.pdf" rel="noreferrer"
            target="_blank">
              CV
          </a>&nbsp;&nbsp;
          <a className="icon" href="https://www.linkedin.com/in/anika-m/" rel="noreferrer" target="_blank">
            <FontAwesomeIcon size="1x" color='black' icon={faLinkedin} />
          </a>
          </h5>
        </Box>
      </Container>
    </div>
  );
}
